import React from "react";

const About = () => {
  return (
    <div className="p-4 bg-white rounded-lg shadow-md flex flex-col items-center justify-center ml-56">
      <h1 className="text-3xl font-bold mb-4">About Real-Time Notifier</h1>
      <p className="text-lg">
        Real-Time Notifier is a real-time notification npm package using
        Node.js, Express, and Socket.io.
      </p>
    </div>
  );
};

export default About;
